import { HttpAction } from './http.types';

export const HTTP_GET: string = 'HTTP_GET';
export const HTTP_POST: string = 'HTTP_POST';
export const HTTP_PUT: string = 'HTTP_PUT';
export const HTTP_DELETE: string = 'HTTP_DELETE';
export const HTTP_REQUEST_COMPLETE: string = 'HTTP_REQUEST_COMPLETE';

export function httpGet(sectionName: string, url?: string): HttpAction {
	return httpStartHttpAction(sectionName, HTTP_GET, url);
}

export function httpPost(sectionName: string, url?: string): HttpAction {
	return httpStartHttpAction(sectionName, HTTP_POST, url);
}

export function httpPut(sectionName: string, url?: string): HttpAction {
	return httpStartHttpAction(sectionName, HTTP_PUT, url);
}

export function httpDelete(sectionName: string, url?: string): HttpAction {
	return httpStartHttpAction(sectionName, HTTP_DELETE, url);
}

export function httpRequestComplete(
	sectionName: string,
	url?: string
): HttpAction {
	return httpCompleteHttpAction(sectionName, HTTP_REQUEST_COMPLETE, url);
}

function httpStartHttpAction(
	sectionName: string,
	action: string,
	url?: string
): HttpAction {
	return {
		type: action,
		payload: {
			name: sectionName,
			loading: true,
			succes: false,
			error: false,
			method: action,
			url: url
		}
	};
}

function httpCompleteHttpAction(
	sectionName: string,
	action: string,
	url?: string
): HttpAction {
	return {
		type: action,
		payload: {
			name: sectionName,
			loading: false,
			succes: true,
			error: false,
			url: url
		}
	};
}
